import { FC, ReactElement, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { generateOwnCollectionMeilisearchFilterQuery } from '../../../entities/OwnCollection/OwnCollection';
import { fetchProductCategoryPageData } from '../../../redux/@products/productCategory/productCategoryActions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';

interface ConnectedOwnCollectionPageChildProps {
    baseFilter: string;
}

interface ConnectedOwnCollectionPageWrapperProps {
    children: (childProps: ConnectedOwnCollectionPageChildProps) => ReactElement;
}

export const ConnectedOwnCollectionPageWrapper: FC<ConnectedOwnCollectionPageWrapperProps> = ({
    children,
}): ReactElement => {
    const { categorySlug = '' } = useParams();

    const dispatch = useTypedDispatch();

    const productCategories = useTypedSelector(state => state.productCategoriesSlice.productCategories);
    const activeProductCategory = useTypedSelector(state => state.productCategorySlice.activeProductCategory);

    useEffect((): void => {
        if (productCategories.length === 0) {
            return;
        }

        const productCategorySlugs = productCategories.map(productCategory => productCategory.slug);
        const isProductCategory = productCategorySlugs.includes(categorySlug);

        if (isProductCategory) {
            dispatch(fetchProductCategoryPageData({
                slug: categorySlug,
                subCategory: undefined,
                subSubCategory: undefined,
            }));
        }
    }, [productCategories, categorySlug]);

    const categoryName = categorySlug && activeProductCategory
        ? activeProductCategory.name
        : '';

    const baseFilter = !categorySlug || categoryName
        ? generateOwnCollectionMeilisearchFilterQuery(categoryName)
        : '';

    return (
        <div>
            {children({ baseFilter })}
        </div>
    );
};
